import { createSlice } from '@reduxjs/toolkit';

const seasonSlice = createSlice({
  name: 'season',
  initialState: {
    count:0,
    limit:0,
    records:[]
  },
  reducers: {
    addSeason: (state, action) => {
      return action.payload
    }
  },
});

export const { addSeason } = seasonSlice.actions;
export default seasonSlice.reducer;
